var _path, _mask, _g, _path2, _path3, _mask2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProtopieLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44.5C34.1503 44.5 44 34.6503 44 22.5C44 10.3497 34.1503 0.5 22 0.5C9.84974 0.5 0 10.3497 0 22.5C0 34.6503 9.84974 44.5 22 44.5Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0231 14.0723C13.84 14.0723 13.6723 14.1495 13.5585 14.276C13.456 14.3831 13.3923 14.5288 13.3877 14.6873V14.7294C13.3897 14.8046 13.4045 14.8752 13.4309 14.94C13.432 14.9457 13.4344 14.9503 13.4365 14.9561C13.4571 15.005 13.4832 15.0504 13.5162 15.0927C13.5275 15.1088 13.5403 15.1236 13.5539 15.1371C13.5561 15.1406 13.5595 15.1439 13.563 15.1474L15.5882 17.5519L16.3195 18.4198L18.5089 21.0181L19.2401 21.8848L21.2004 24.212L21.9303 25.0786V31.1577C21.9704 31.1577 22.0092 31.1566 22.0478 31.1533C22.4316 31.1261 22.7779 30.9619 23.0387 30.7102C23.04 30.7102 23.04 30.7102 23.04 30.7089L23.2552 30.4527L28.5131 24.212L30.3128 22.075C30.3219 22.066 30.3298 22.0556 30.3379 22.0455C30.3765 21.9976 30.4072 21.9439 30.4299 21.8848C30.4585 21.8142 30.4733 21.7368 30.4733 21.6546V14.7078C30.4733 14.5403 30.4083 14.3864 30.3014 14.2749C30.1863 14.1495 30.021 14.0723 29.8365 14.0723H14.0231Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0231 14.0723C13.84 14.0723 13.6723 14.1495 13.5585 14.276C13.456 14.3831 13.3923 14.5288 13.3877 14.6873V14.7294C13.3897 14.8046 13.4045 14.8752 13.4309 14.94C13.432 14.9457 13.4344 14.9503 13.4365 14.9561C13.4571 15.005 13.4832 15.0504 13.5162 15.0927C13.5275 15.1088 13.5403 15.1236 13.5539 15.1371C13.5561 15.1406 13.5595 15.1439 13.563 15.1474L15.5882 17.5519L16.3195 18.4198L18.5089 21.0181L19.2401 21.8848L21.2004 24.212L21.9303 25.0786V31.1577C21.9704 31.1577 22.0092 31.1566 22.0478 31.1533C22.4316 31.1261 22.7779 30.9619 23.0387 30.7102C23.04 30.7102 23.04 30.7102 23.04 30.7089L23.2552 30.4527L28.5131 24.212L30.3128 22.075C30.3219 22.066 30.3298 22.0556 30.3379 22.0455C30.3765 21.9976 30.4072 21.9439 30.4299 21.8848C30.4585 21.8142 30.4733 21.7368 30.4733 21.6546V14.7078C30.4733 14.5403 30.4083 14.3864 30.3014 14.2749C30.1863 14.1495 30.021 14.0723 29.8365 14.0723H14.0231Z",
    fill: "url(#paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9303 28.5587V31.1579C21.4997 31.1579 21.1091 30.987 20.8219 30.7102C20.8208 30.7102 20.8208 30.7102 20.8208 30.7092L20.6056 30.4529L15.3477 24.2122L13.5583 22.0877C13.5537 22.0855 13.5504 22.0809 13.548 22.0763L13.5195 22.0434C13.5173 22.041 13.516 22.0388 13.514 22.0364C13.4796 21.9898 13.4501 21.9396 13.4307 21.8849C13.4044 21.8201 13.3897 21.7495 13.3875 21.6766V21.6334C13.3875 21.6197 13.3886 21.6058 13.391 21.5922C13.4033 21.4489 13.4648 21.321 13.5583 21.2209C13.6734 21.0968 13.8396 21.0183 14.0228 21.0183H15.5756L16.3057 21.8849L18.266 24.2122L21.4801 28.0268L21.9292 28.5599L21.9303 28.5587Z",
    fill: "#FCD1CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9303 25.0793V28.5584L21.9292 28.5595L21.4807 28.0266L18.2665 24.2123L16.3059 21.8855L15.5756 21.0183L13.5465 18.6113C13.538 18.6018 13.5295 18.5911 13.521 18.5802C13.4837 18.5324 13.4527 18.479 13.4301 18.4201C13.4046 18.3551 13.3897 18.2845 13.3875 18.2099V18.1671C13.3917 18.008 13.4558 17.8649 13.5583 17.7561C13.6726 17.6299 13.839 17.552 14.0228 17.552H15.5884L16.3198 18.4201L18.509 21.0183L19.2393 21.8855L21.2 24.2123L21.9303 25.0793Z",
    fill: "#FF9D8D"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 10,
    width: 26,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 34.9204H34.2355V10.3098H9.625V34.9204Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.742,
    y1: 12.0496,
    x2: 15.5854,
    y2: 25.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtopieLogo);
export default __webpack_public_path__ + "static/media/protopie-logo.4ad060cf885d0be9a445e589f7f0518d.svg";
export { ForwardRef as ReactComponent };